import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink, Link } from "react-router-dom";
import { Header } from "./components/Header";
import { ShimmerTable } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";
import { type } from "@testing-library/user-event/dist/type";

const API_URL = "/api";

export default function ScoringGuide() {
  const { id } = useParams();
  console.log("🔎 Route id:", id);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [company, setCompany] = useState(null);
  const [transactionData, setTransactionData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checklistFormData, setChecklistFormData] = useState([]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getTransactionDetails/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("📥 Full API Response:", data);
        setTransactionData(data);
        console.log("transactionData:", transactionData);
        // setFormData(data?.DocumentCheckList || {});
        setFormData(data); // keep full object for Loan Info
        setCompany(data);
        console.log("Data:", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setFormData(transactionData);
    setChecklistFormData(transactionData?.DocumentCheckList || []);
    setIsEditing(false);
  };

  const handleInputChange = (sectionKey, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const { _id, ...rest } = formData;
    if (!_id) {
      alert("Missing _id");
      return;
    }
    // Remove any fields with undefined values
    const cleanedData = {};
    for (const key in rest) {
      if (rest[key] !== undefined) {
        cleanedData[key] = rest[key];
      }
    }
    const updatePayload = {
      _id: _id, // Make sure it's a string
      update_data: cleanedData,
    };

    try {
      const response = await fetch(
        "http://localhost:8000/riverchain/techop/v1.1/updateCompanyLog",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        }
      );

      const resultText = await response.text();

      if (!response.ok) {
        console.error("❌ Update failed:", resultText);
        alert("Update failed:\n" + resultText);
      } else {
        toast.success("Company log updated successfully");
      }
    } catch (error) {
      console.error("🚨 Network error:", error);
      toast.danger("An error occurred while updating the profile.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // Utility: format date values into DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if invalid date
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  const today = new Date();
  const formatted = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long", // 👈 gives full month name
    year: "numeric",
  });

  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <Header />
        </main>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back to Transaction List
            </NavLink>

            <br />
            <br />
            <NavLink
              to={`/ViewTransactionList/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Loan Details
            </NavLink>

            <NavLink
              to={`/Drawdowns/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Drawdowns
            </NavLink>

            <NavLink
              to={`/ApplicationChecklist/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Application Checklist
            </NavLink>

            <NavLink
              to={`/ScoreCard/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scorecard
            </NavLink>

            <NavLink
              to={`/TransactionSummary/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Transaction Summary
            </NavLink>

            <NavLink
              to={`/TermSheet/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Term Sheet
            </NavLink>

            <NavLink
              to={`/Payments/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Payments
            </NavLink>
            <NavLink
              to={`/RepaymentAndInterest/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Repayment & Interest(Term)
            </NavLink>

            <NavLink
              to={`/ScoringCriteriaTf/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scoring Criteria
            </NavLink>

            <NavLink
              to={`/ScoringGuide/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scoring Guide
            </NavLink>

            <NavLink
              to={`/InterestCalculations/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Interest Calculations
            </NavLink>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "15px" }}>Scoring Guide</h3>
              <div>
                {isEditing && (
                  <button
                    className="btn btn-secondary me-2 btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    if (isEditing) {
                      setIsSubmitting(true);
                      await handleSubmit();
                      setIsSubmitting(false);
                    } else {
                      setFormData(transactionData);
                      setIsEditing(true);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? isSubmitting
                      ? "Submitting..."
                      : "Submit"
                    : "Edit"}
                </button>
              </div>
            </div>

            {loading || !transactionData ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <>
                <div className="col-md-12">
                  <table>
                    <thead>
                      <tr style={{ backgroundColor: "blue", color: "white" }}>
                        <th colSpan={"3"}>Company Score</th>
                      </tr>
                      <tr
                        style={{
                          borderBlock: "2px solid black",
                          textAlign: "center",
                        }}
                      >
                        <th>Range</th>
                        <th>Category</th>
                        <th>Implications</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ textAlign: "center" }}>
                        <td>Between 70 and 100 points </td>
                        <td style={{ backgroundColor: "green" }}>A</td>
                        <td>
                          Lowest risk category and probability of default.
                          Clients suitable for loan financing.{" "}
                        </td>
                      </tr>
                      <tr style={{ textAlign: "center" }}>
                        <td>Between 40 and 69 points </td>
                        <td style={{ backgroundColor: "#bebebeff" }}>B</td>
                        <td>
                          Average risk category and probability of default.
                          Clients suitable for factoring transactions and loan
                          financing with conservative security and monitoring
                          provisions.{" "}
                        </td>
                      </tr>
                      <tr style={{ textAlign: "center" }}>
                        <td>Between 0 and 39 points</td>
                        <td style={{ backgroundColor: "#eaa2e7ff" }}>C</td>
                        <td>
                          High risk category and probability of default. Clients
                          could be suitable for factoring transactions and loan
                          financing with very conservative security and
                          monitoring provisions.{" "}
                        </td>
                      </tr>
                      <tr style={{ textAlign: "center" }}>
                        <td>Less than 0 points</td>
                        <td style={{ backgroundColor: "#862d1dff" }}>D</td>
                        <td>
                          Highest risk category and probability of default.
                          Clients generally should not be financed unless with
                          explicit exception granted by management.{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br></br>
                <table>
                  <thead>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#4779a1ff",
                          paddingRight: "1100px",
                        }}
                      >
                        Transaction Score
                      </th>
                    </tr>
                  </thead>
                </table>
                <div className="row">
                  <div className="col-md-6">
                    <table>
                      <thead>
                        <tr
                          style={{
                            textAlign: "center",
                            borderBlock: "2px solid black",
                          }}
                        >
                          <th>Transaction Business Score Range</th>
                          <th style={{ paddingLeft: "60px" }}>Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ textAlign: "center" }}>
                          <td>Between 61 and 85 points</td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#76c8d4ff",
                            }}
                          >
                            A
                          </td>
                        </tr>
                        <tr style={{ textAlign: "center" }}>
                          <td>Between 31 and 60 points</td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#d88273ff",
                            }}
                          >
                            B
                          </td>
                        </tr>
                        <tr style={{ textAlign: "center" }}>
                          <td>Between 0 and 30 points </td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#c4dba7ff",
                            }}
                          >
                            C
                          </td>
                        </tr>
                        <tr style={{ textAlign: "center" }}>
                          <td>Less than 0 points</td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#cc95e2ff",
                            }}
                          >
                            D
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col-md-6">
                    <table>
                      <thead>
                        <tr
                          style={{
                            textAlign: "center",
                            borderBlock: "2px solid black",
                          }}
                        >
                          <th>Transaction Score Range</th>
                          <th style={{ paddingLeft: "60px" }}>Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ textAlign: "center" }}>
                          <td>Between 30 and 50 points</td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#76c8d4ff",
                            }}
                          >
                            I
                          </td>
                        </tr>
                        <tr style={{ textAlign: "center" }}>
                          <td>Between 16 and 29 points </td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#8ddabbff",
                            }}
                          >
                            II
                          </td>
                        </tr>
                        <tr style={{ textAlign: "center" }}>
                          <td>Between 0 and 15 points</td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#daebb2ff",
                            }}
                          >
                            III
                          </td>
                        </tr>
                        <tr style={{ textAlign: "center" }}>
                          <td>Less than 0 points </td>
                          <td
                            style={{
                              paddingLeft: "60px",
                              backgroundColor: "#d78ebdff",
                            }}
                          >
                            IV
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <br></br>
                <div className="col-md-12">
                  <thead>
                    <tr>
                      <th
                        colSpan={"5"}
                        style={{ borderBlock: "2px solid black" }}
                      >
                        Business score/Transaction Score
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th style={{ paddingLeft: "160px", textAlign: "center" }}>
                        A
                      </th>
                      <th style={{ paddingLeft: "160px" }}>B</th>
                      <th style={{ paddingLeft: "160px", textAlign: "center" }}>
                        C
                      </th>
                      <th style={{ paddingLeft: "160px", textAlign: "center" }}>
                        D
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>I</td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#bcda8bff",
                        }}
                      >
                        Good
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#bcda8bff",
                        }}
                      >
                        Good
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#e7cb8fff",
                        }}
                      >
                        Medium
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                    </tr>
                    <tr>
                      <td>II</td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#bcda8bff",
                        }}
                      >
                        Good
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#bcda8bff",
                        }}
                      >
                        Good
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#e7cb8fff",
                        }}
                      >
                        Medium
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                    </tr>
                    <tr>
                      <td>III</td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#e7cb8fff",
                        }}
                      >
                        Medium
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#e7cb8fff",
                        }}
                      >
                        Medium
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#e7cb8fff",
                        }}
                      >
                        Medium
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                    </tr>
                    <tr>
                      <td>IV</td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                      <td
                        style={{
                          paddingLeft: "160px",
                          backgroundColor: "#ed3636ff",
                        }}
                      >
                        Poor
                      </td>
                    </tr>
                    <br></br>
                    <tr>
                      <td></td>
                      <td>Good Quality:</td>
                      <td>Transactions should be financed</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Medium Quality:</td>
                      <td>
                        Can be financed with a strong security an extensive
                        monitoring.
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Poor Quality:</td>
                      <td>
                        Can only be financed with explicit decision of the CEO.
                      </td>
                    </tr>
                  </tbody>
                  <br></br>
                  <p>
                    Poor quality transactions require strict monitoring
                    activity. If significant deterioration of the creditability
                    is probable, additional security should be explored.
                    Furthermore, an action plan has to be prepared in order to
                    minimize the Lender's potential loss.
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
